//CODE FROM https://github.com/react-component/upload/blob/master/src/traverseFileTree.js with addition callback after all files visited

function loopFiles(item, callback) {
  const dirReader = item.createReader();
  let fileList = [];

  function sequence() {
    dirReader.readEntries((entries) => {
      const entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList);

      // Check if all the file has been viewed
      const isFinished = !entryList.length;

      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }

  sequence();
}

const traverseFileTree = (files, callback, isAccepted, endCallback) => {
  const _traverseFileTree = (item, path, endItemCallback) => {
    path = path || '';
    if (item.isFile) {
      item.file((file) => {
        if (isAccepted(file)) {
          // https://github.com/ant-design/ant-design/issues/16426
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true,
              },
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false,
              },
            });
          }

          callback([file]);
          endItemCallback();
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, (entries) => {
        if (entries.length === 0) {
          endItemCallback();
          return;
        }

        let completed = 0;
        entries.forEach((entryItem) => {
          _traverseFileTree(entryItem, `${path}${item.name}/`, () => {
            completed++;
            if (completed === entries.length) {
              endItemCallback();
            }
          });
        });
      });
    }
  };

  let completed = 0;
  files.forEach(file => {
    _traverseFileTree(file.webkitGetAsEntry(), null, () => {
      completed++;
      if (completed === files.length) {
        endCallback();
      }
    });
  });
};

export default traverseFileTree;